<script>
  import Keyframe from "./Keyframe.svelte";
  import Storyframe from "./Storyframe.svelte";

  export let memory;
</script>

<key>
  <Keyframe keyframeData={memory['keyframe']}/>
</key>

{#each memory['storyFrames'] as frame}
  <layout>
    <Storyframe storyframeData={frame} />
  </layout>
{/each}

<style>
  layout {
    height: 85vh;
  }
  key {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
</style>
